import { h } from 'vue';

export default {

    props:
    {

        color:
        {
            type: String,
            default: 'primary', // 'primary', 'secondary', 'success', 'warning', 'danger', 'inverse'
        },

        size:
        {
            type: String,
            default: null, // 'xsmall', 'small', 'medium', 'large'
        },

        divClass:
        {
            type: String,
            default: '',
        }
    },


    render()
    {
        return h(
            'div',
            {

                class:
                    [
                        'vh-loader',
                        `vh-loader-${this.color}`,
                        this.size && `vh-loader-${this.size}`,
                        this.divClass
                    ],
            },
        );
    },
};
